import { ProviderConfig, ProviderTypes } from 'types';
import { XfinityTheme } from 'config/themes';

export const Comcast: ProviderConfig = {
  providerType: ProviderTypes.MSO,
  providerCode: 'xfinity',
  dcCode: 'Comcast',
  name: 'Xfinity',
  displayName: 'Xfinity',
  reskinTheme: XfinityTheme,
  reskinTitle: 'Xfinity Authorized Dealer',
  showPricingDisclaimer: true,
  broadbandDisplayType: 'linkout_url',
  disclaimerDisplaySettings: {
    showContractDisclaimer: true,
    showOfferDisclaimer: true,
    showPromotionsDisclaimer: true,
  },
};
